<template>
	<div>
        <div class="w-full flex flex-col">
            <div class="modal-header flex items-center justify-between cursor-move">
                <h1 class="flex-1 text-2xl">Edit Project</h1>
                <div @click="hideModal">
                    <inline-svg name="close" classes="w-5 h-5 text-white fill-current cursor-pointer"></inline-svg>
                </div>
            </div>
	    	<div class="p-8">
				<div class="flex flex-col divide-y divide-gray-200">
					<div class="flex py-4">
			    		<label class="w-48 text-lg" for="name">Name</label>
			    		<input class="form-input" type="text" name="name" v-model="project.name" size="50" required>
			    	</div>
					<div class="flex py-4">
			    		<label class="w-48 text-lg" for="project_type">Project Type</label>
						<select class="mt-0 max-w-fit form-select h-full" name="project_type" v-model="project.project_type" required>
							<option value=""></option>
							<option value="Consolidation">Consolidation</option>
							<option value="Expansion">Expansion</option>
							<option value="New Location">New Location</option>
							<option value="Renewal">Renewal</option>
						</select>
			    	</div>
			    	<div class="flex py-4">
			    		<label class="w-48 text-lg" for="priority">Priority</label>
						<select class="mt-0 max-w-fit form-select h-full" name="priority" v-model="project.priority" required>
							<option value=""></option>
							<option value="Low">Low</option>
							<option value="Medium">Medium</option>
							<option value="High">High</option>
							<option value="Urgent">Urgent</option>
						</select>
				    </div>
			    	<div class="flex py-4">
			    		<label class="w-48 text-lg" for="stage">Stage</label>
						<select class="mt-0 max-w-fit form-select h-full" name="stage" v-model="project.stage" required>
							<option value=""></option>
							<option value="Activated Assignment">Activated Assignment</option>
							<option value="Approval">Approval</option>
							<option value="Build-out">Build-out</option>
							<option value="Comps Research">Comps Research</option>
							<option value="Final Cut">Final Cut</option>
							<option value="Lease Negotiation">Lease Negotiation</option>
							<option value="Move In">Move In</option>
							<option value="Negotiation">Negotiation</option>
							<option value="RFP Process">RFP Process</option>
							<option value="Sign Off">Sign Off</option>
							<option value="Tour of Comps">Tour of Comps</option>
						</select>
				    </div>
			    	<div class="flex py-4">
			    		<label class="w-48 text-lg" for="status">Status</label>
						<select class="mt-0 max-w-fit form-select h-full" name="status" v-model="project.status" required>
							<option value=""></option>
							<option value="Active">Active</option>
							<option value="Holding">Holding</option>
							<option value="Archived">Archived</option>
							<option value="Complete">Complete</option>
						</select>
				    </div>
					<div class="flex py-4">
			    		<label class="w-48 text-lg" for="start_date">Start Date</label>
		    			<date-picker
		    				v-model="project.start_date"
		    				lang="en"
		    				:first-day-of-week="7"
		    				value-type="format"
		    				format="MM/DD/YYYY"
		    				input-name="start_date"
		    				input-class="form-input"
		    				:input-attr="{ size: 11, required: true }">
						</date-picker>
			    	</div>
					<div class="flex py-4">
			    		<label class="w-48 text-lg" for="end_date">End Date</label>
		    			<date-picker
		    				v-model="project.end_date"
		    				lang="en"
		    				:first-day-of-week="7"
		    				value-type="format"
		    				format="MM/DD/YYYY"
		    				input-name="end_date"
		    				input-class="form-input"
		    				:input-attr="{ size: 11, required: true }">
						</date-picker>
			    	</div>
			    	<div class="flex py-4">
			    		<label class="w-48 text-lg" for="property_type">Property Type</label>
						<select class="mt-0 max-w-fit form-select h-full" name="property_type" v-model="project.property_type" required>
							<option value=""></option>
							<option value="Office">Office</option>
							<option value="Industrial">Industrial</option>
							<option value="Flex">Flex</option>
							<option value="Land">Land</option>
							<option value="Retail">Retail</option>
						</select>
				    </div>
			    	<div class="flex py-4">
			    		<label class="w-48 text-lg" for="property_usage">Property Usage</label>
						<select class="mt-0 max-w-fit form-select h-full" name="property_usage" v-model="project.property_usage" required>
							<option value=""></option>
							<option value="Corporate HQ">Corporate HQ</option>
							<option value="Operations">Operations</option>
							<option value="Production">Production</option>
							<option value="Sublet">Sublet</option>
							<option value="Vacant">Vacant</option>
						</select>
				    </div>
			    	<div class="flex py-4">
			    		<label class="w-48 text-lg" for="property_region">Property Region</label>
						<select class="mt-0 max-w-fit form-select h-full" name="property_region" v-model="project.property_region" required>
							<option value=""></option>
							<option value="Central">Central</option>
							<option value="Mid-Atlantic">Mid-Atlantic</option>
							<option value="Northeast">Northeast</option>
							<option value="Northwest">Northwest</option>
							<option value="Outside USA">Outside USA</option>
							<option value="Southeast">Southeast</option>
							<option value="Southwest">Southwest</option>
						</select>
				    </div>
					<div class="flex py-4">
			    		<label class="w-48 text-lg" for="required_sq_ft">Required Sq. Ft.</label>
			    		<number-input name="required_sq_ft" v-model="project.required_sq_ft" classes="text-sm text-right"></number-input>
			    	</div>
					<div class="flex mb-4 border-t border-b border-gray-300 py-4">
			    		<label class="w-48 text-lg" for="description">Description</label>
			    		<textarea class="form-textarea" cols="80" rows="5" name="description" v-model="project.description"></textarea>
			    	</div>
			    </div>
	    	</div>
	    </div>
        <div class="bg-gray-100 p-4">
            <div class="text-right">
				<button class="btn btn-secondary mr-2" @click.prevent="hideModal">Close</button>
	    		<button @click.prevent="save" type="button" class="btn btn-green">Save Project</button>
            </div>
        </div>
	</div>
</template>

<script>
    import DatePicker from 'vue2-datepicker'

    export default {
    	components: { DatePicker },

    	props: {
    		projectData: {
    			type: [Object, Array],
    			required: true
    		}
    	},

		data: function () {
		    return {
		    	project: this.projectData,
		    	errors: []
		    }
		},

		methods: {
			save() {
				axios.patch('/projects/' + this.project.id, this.project).then(response => {
					this.$notify({
						type: 'success',
						title: 'Success',
						text: response.data.message
					});

					this.hideModal();
                }).catch(error => {
					this.$notify({
						type: 'error',
						title: 'Error',
						text: error.response.data.message
					});
                });
			}
		}
    }
</script>